var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrecheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#0C0C22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8175 8.1952C19.0939 8.52552 19.0515 9.01848 18.7228 9.29625L10.2453 16.4588L9.74474 15.8607L9.72714 15.8397M18.8175 8.1952C18.541 7.86488 18.0504 7.82228 17.7216 8.10005L18.8175 8.1952ZM17.7216 8.10005L9.7516 14.8339L17.7216 8.10005ZM9.7516 14.8339L6.3647 10.9205C6.08284 10.5948 5.59157 10.5604 5.26743 10.8436C4.94328 11.1268 4.90901 11.6204 5.19087 11.9461L9.01282 16.3621C9.32854 16.7269 9.87707 16.77 10.2453 16.4588L9.74474 15.8607",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.74498 15.8247L18.8175 8.1952L17.7216 8.10005L9.7516 14.8339L9.74498 15.8247Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72714 15.8397L9.74474 15.8607L9.74498 15.8247L9.72714 15.8397Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecheck);
export default __webpack_public_path__ + "static/media/precheck.aaea787792156306b5b610ee28ab2b30.svg";
export { ForwardRef as ReactComponent };